module.exports = __webpack_public_path__ + "img/service_img2.27b94008.png";